import React from 'react';

const IDCUModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e) => {
    // Close modal when clicking the overlay (outside the modal content)
    if (e.target.className === 'modal-overlay') {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal-content idcu-modal-content">
        <button
          className="modal-close-button"
          onClick={onClose}
          aria-label="Close modal"
        >
          ×
        </button>
        <img src={`${process.env.PUBLIC_URL}/IDCU_svg.svg`} alt="IDCU Logo" style={{width: '120px', marginBottom: '10px'}} />
        <div className="modal-scroll-content">
          <div className="terminal-text">
            I.D.C.U
            
            CLASSIFIED DOCUMENT - SECURITY CLEARANCE
            LEVEL Ψ
            NEURANET SYSTEM ACCESS PROTOCOL

            WARNING: You are accessing a restricted IDCU
            neural interface system. This advanced
            quantum-enabled platform has been authorized
            for use in monitoring and maintaining
            interdimensional stability across designated
            reality matrices.

            AUTHORIZED OPERATIONS:
            - Quantum Matrix Analysis and Stabilization
            - Reality Stack Integrity Monitoring
            - Interdimensional Data Collection
            - Anomaly Detection and Containment

            NOTICE: All operations are logged and
            monitored. Unauthorized access or misuse of
            this system will result in immediate
            quantum-temporal lockout and possible
            reality displacement.
          </div>
        </div>
        
        <button 
          className="terminal-button"
          onClick={onClose}
        >
          [ACKNOWLEDGE]
        </button>
      </div>
    </div>
  );
};

export default IDCUModal;